



































import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import getUrlParam from '@/common/utils/getUrlParam';
import fetch from "@/common/api/fetch";
import { AxiosPromiseData, AxiosPromiseError } from "@/common/interface";
import ActivitySection from "../common/ActivitySection.vue";
import desensitizeName from '@/common/utils/desensitizeName';
@Component({
  components: {
    "activity-section": ActivitySection,
  }
})
export default class GachaChaProgress extends Vue {
  @Getter("urlUid") urlUid!: string;
  @Getter('openId') openId!: string;
  @Getter('userAwardInfo') userAwardInfo!:any
  @Getter("gachaTypeParameter") gachaTypeParameter!: object;
  @Getter("studentInfo") studentInfo!: object;
  @Getter("section") section!: object;
  desensitizeName:Function = desensitizeName;
  getUrlParam: Function = getUrlParam;
}
